import moment from "moment";
import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/atoms/breadcrumb/Breadcrumb";
import Loading from "../../components/atoms/loading/Loading";
import MproductListCard from "../../components/molecules/MproductListCard";
import { renderStatusColor } from "../../components/molecules/MtransactionTicketCard";
import { useFetchRetailTransactionTicket } from "../../hooks/retail_transaction_ticket";
import { formatRupiah } from "../../helpers/common";

export const retailTransactionTicketRoute = (code?: string) => {
  return [
    {
      id: 1,
      path: "/transaction-ticket",
      name: "Transaction (Ticket)",
    },
    {
      id: 2,
      path: `/transaction-ticket/${code}`,
      name: "Detail",
    },
  ];
};

const TransactionTicketDetail: React.FC = () => {
  const params = useParams();
  const { data, isError, isLoading } = useFetchRetailTransactionTicket(
    params?.code || ""
  );

  if (isError) {
    return <h1>Something went wrong! Please refresh the page</h1>;
  } else if (isLoading) {
    return (
      <div className="w-full flex justify-center mt-20">
        <Loading />
      </div>
    );
  } else if (data) {
    return (
      <main className="-mt-1">
        <aside>
          {<Breadcrumb data={retailTransactionTicketRoute(params.code)} />}
          <hr className="mt-5" />
        </aside>

        <main className="w-full">
          <section className="mt-5">
            <article>
              <h1 className="text-lg font-Bold">Transaction Details</h1>
            </article>
          </section>
          <section className="mt-5 w-full h-full flex gap-[2%]">
            <aside className="xl:w-2/3 w-full h-auto">
              {/* <div
                id="review"
                className="rounded-lg shadow-md bg-white p-5 mb-5"
              >
                <article>
                  <h1 className="text-textPrimary">Review from Customer</h1>
                  <hr className="mt-4" />
                  <h1 className="my-4 text-textPrimary">Message</h1>
                  <TextArea name="text" />
                </article>
              </div> */}

              <div id="info" className="rounded-lg shadow-md bg-white p-5">
                <article className="w-full ">
                  <div className="flex">
                    <div className="w-1/2 text-sm">
                      <h1 className="text-textPrimary">Transaction ID</h1>
                      <h1 className="text-textSecondary mt-1.5">
                        {data?.code}
                      </h1>
                    </div>
                    <div className="w-1/2 text-sm">
                      <h1 className="text-textPrimary">Status</h1>
                      <h1
                      className={"mt-1.5 " + renderStatusColor(data.status)}
                      >
                        {data?.status}
                      </h1>
                    </div>
                  </div>
                  <hr className="mt-4" />
                </article>

                <article className="mt-4">
                  <div className="w-full">
                    <h1 className="text-textPrimary">Ticket</h1>
                  </div>
                  <div className="grid grid-cols-2 gap-5 mt-4">
                    <MproductListCard
                      quantity={data.quantity}
                      image={data.image_url}
                      name={data.title}
                      variant={data.sub_title}
                      border={true}
                    />
                  </div>
                  <hr className="mt-5" />
                </article>

                {/* <article className="mt-4">
                  <div className="w-full">
                    <h1 className="text-textPrimary">Address</h1>
                  </div>
                  <div className="mt-1.5 font-rom text-sm text-textPrimary w-full">
                    <p>
                      {data.buyer_shipping_address.recipient} |{" "}
                      {data.buyer_shipping_address.phone}
                    </p>
                    <p className="mt-0.5">
                      {data.buyer_shipping_address.address}
                    </p>
                  </div>
                  <hr className="mt-4" />
                </article> */}

                {/* <article className="mt-4">
                  <div className="w-full">
                    <h1 className="text-textPrimary">
                      Courier <span className="font-rom">(Must Same)</span>
                    </h1>
                  </div>
                  <div className="mt-1.5 font-rom text-sm text-textPrimary w-full">
                    <p>
                      {data.shipping_provider} - Reguler{" "}
                      <span className="text-textSecondary">
                        ({formatRupiah(data.buyer_shipping_cost)})
                      </span>
                    </p>
                  </div>
                </article> */}
              </div>

              <div
                id="invoice"
                className="rounded-lg shadow-md bg-white p-5 mt-5"
              >
                <article className="w-full">
                  <div className="flex justify-between w-full text-sm">
                    <div className="w-1/2 flex justify-start gap-1">
                      <h1 className="text-textPrimary">Customer :</h1>
                      <h1 className="text-textPrimary font-rom">
                        {data.username}
                      </h1>
                    </div>
                    <div className="w-1/2 flex justify-end gap-1 font-rom">
                      <h1 className="text-textPrimary">Transaction Date :</h1>
                      <h1 className="text-textPrimary">
                        {moment(data.created_at).format("llll")}
                      </h1>
                    </div>
                  </div>
                  <hr className="mt-4" />
                </article>
                <article className="mt-4 flex flex-col">
                  <div className="flex bg-stroke rounded-md px-4 py-2 font-rom text-sm">
                    <div className="w-2/5">Ticket</div>
                    <div className="w-1/5 flex justify-end">Price(IDR)</div>
                    <div className="w-1/5 flex justify-end">Quantity</div>
                    <div className="w-1/5 flex justify-end">Subtotal(IDR)</div>
                  </div>
                  <div>
                    {
                      <div className="">
                        <div className="flex px-4 py-2 font-rom my-2.5">
                          <div className="w-2/5">
                            <MproductListCard
                              quantity={data.quantity}
                              image={data.image_url}
                              name={data.title}
                              variant={data.sub_title}
                            />
                          </div>
                          <div className="w-1/5 flex justify-end text-sm">
                            <span>{formatRupiah(data.price)}</span>
                          </div>
                          <div className="w-1/5 flex justify-end text-sm">
                            <span>{data.quantity}</span>
                          </div>
                          <div className="w-1/5 flex justify-end text-sm">
                            <span>
                              {formatRupiah(data.price * data.quantity)}
                            </span>
                          </div>
                        </div>
                        <hr />
                      </div>
                    }
                  </div>
                  <div className="flex justify-end gap-2 w-1/2 mt-4 self-end">
                    <div className="w-1/2 border-r b-border-stroke flex flex-col gap-y-1.5 font-rom text-sm">
                      <h1 className="font-med">Total Selling</h1>
                    </div>
                    <div className="w-1/2 flex flex-col items-end gap-y-1.5 font-rom text-sm pr-4">
                      <h1 className="font-med text-primary">
                        {formatRupiah(data.total_price)}
                      </h1>
                    </div>
                  </div>
                </article>
              </div>
            </aside>
          </section>
        </main>
      </main>
    );
  }

  return <div></div>;
};

export default TransactionTicketDetail;
